module.exports = __WEBPACK_EXTERNAL_MODULE_redux_saga_effects__;